module.exports = __webpack_public_path__ + "static/media/empty1.808bfdca.png";